import * as React from "react";
import { useLocation } from "react-router-dom";

// The value used here is the last path segment in the URL
export enum DeviceTab {
  Details = "details",
  Tokens = "tokens",
  Datasets = "datasets",
  Files = "files",
}

function deriveActiveTabFromUrl(path: string | undefined) {
  switch (path) {
    case DeviceTab.Tokens:
      return DeviceTab.Tokens;
    case DeviceTab.Datasets:
      return DeviceTab.Datasets;
    case DeviceTab.Files:
      return DeviceTab.Files;
    case DeviceTab.Details:
      return DeviceTab.Details;
    default:
      return DeviceTab.Datasets;
  }
}

export function useActiveDeviceTab() {
  const location = useLocation();
  const path = location.pathname.split("/").pop();

  const [activeTab, setActiveTab] = React.useState(
    deriveActiveTabFromUrl(path),
  );

  React.useEffect(() => {
    setActiveTab(deriveActiveTabFromUrl(path));
  }, [path]);

  return [activeTab, setActiveTab] as const;
}
